<template>
  <nav class="step-bar-container" :aria-label="$t('aria.barre.etapes.intervention')">
    <ol class="step-list">
      <li class="step-item">
        <Step
          :state="isActive(1)"
          :number="1"
          :title="$t('intervention.bar.site')"
          :subtitle="site?.description ?? ''"
        />
      </li>
      <div class="separator" aria-hidden="true"></div>
      <li class="step-item">
        <Step
          :state="isActive(2)"
          :number="2"
          :title="$t('intervention.bar.type')"
          :subtitle="type?.libelle ?? ''"
        />
      </li>
      <div class="separator" aria-hidden="true"></div>
      <li class="step-item">
        <Step
          :state="isActive(3)"
          :number="3"
          :title="$t('intervention.bar.equipement')"
          :subtitle="equipement"
        />
      </li>
      <div class="separator" aria-hidden="true"></div>
      <li class="step-item">
        <Step
          :state="isActive(4)"
          :number="4"
          :title="$t('intervention.bar.object')"
          :subtitle="objet"
        />
      </li>
      <div class="separator" aria-hidden="true"></div>
      <li class="step-item">
        <Step
          :state="isActive(5)"
          :number="5"
          :title="$t('intervention.bar.recurrence')"
        />
      </li>
      <div class="separator" aria-hidden="true"></div>
      <li class="step-item">
        <Step
          :state="isActive(6)"
          :number="6"
          :title="$t('intervention.bar.recap')"
        />
      </li>
    </ol>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Step, { StepState } from '../../../components/ui-components/Step.vue';
import { TypeItems } from '@/models/TypeItems';
import { Site } from '@/models/Site';

export default defineComponent({
    components: {
        Step,
    },
    setup() {
        return {
            StepState,
        };
    },
    props: {
        step: { type: Number, required: true },
    },
    methods: {
        isActive(n: number) {
            if (n < this.step) {
                return StepState.valid;
            } else {
                return n === this.step ? StepState.active : StepState.inactive;
            }
        },
    },
    computed: {
        site(): Site | undefined {
            return this.$store.getters.getInterventionSiteValue;
        },
        type(): TypeItems | undefined  {
            return this.$store.getters.getInterventionTypeValue;
        },
        equipement(): string {
            return this.$store.getters.getInterventionEquipementValue?.libelle ?? '';
        },
        objet(): string {
            return this.$store.getters.getInterventionObjetValue;
        }
    },
});
</script>

<style scoped>
.step-bar-container {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 48px);
  background-color: #fff;
  height: 28px;
  align-items: center;
  padding: 16px 24px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.step-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.step-item {
  display: flex;
  align-items: center;
}
.separator {
  height: 1px;
  background-color: var(--medium-light-grey);
  flex-shrink: 1;
  min-width: 21px;
}
</style>
